import React from 'react'

import ChargebeePricingEmbed from 'components/chargebee-pricing-embed'
import DiscoModal from 'components/ui/disco-modal'
import { trialExpiredModalStyles } from 'components/utils/modalStyles'

import useReloadBusinessWhileVisible from 'hooks/use-reload-business-while-visible'

// can't be dismissed; closes once business data shows the trial is no longer expired
const TrialExpiredModal = (): React.ReactNode => {
  useReloadBusinessWhileVisible()

  return (
    <DiscoModal contentLabel="Choose a plan" style={trialExpiredModalStyles}>
      <ChargebeePricingEmbed />
    </DiscoModal>
  )
}

export default TrialExpiredModal
